import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'fragment', standalone: true })
export class FragmentPipe implements PipeTransform {
  public transform(value: string, fragment = true): SafeHtml {
    const [url, fragmentValue] = value.split('#');

    return fragment ? fragmentValue : url;
  }
}
